<template>
  <v-carousel
    cycle
    hide-delimiter-background
    interval='10000'
  >
    <v-carousel-item
      v-for="(ads,i) in ads"
      :key="i"
      :src="ads.plax"
    >
    <v-layout ma-5 row wrap justify-center align-center>
      <v-flex sm10 md6 lg5 xl4 pa-5>
        <center>
          <v-img :src='ads.logo' class='contain mb-5' max-height='112' max-width='547'/>
        </center>
            <span class='title white--text mt-5'>
              {{ ads.text }}
            </span>
            <center>
              <v-btn
                v-if='!ads.local'
                class='primary mt-4'
                elevation="2"
                :to='ads.url'
              >More Information</v-btn>
              <v-btn
                v-if='ads.local'
                class='primary mt-4'
                elevation="2"
                :href='ads.url'
              >More Information</v-btn>
            </center>
          </v-flex>
          <v-flex sm8 md4 lg4 xl4 hidden-sm-and-down pa-5 >
            <center>
              <v-img
                contain
                :class="ads.css"
                :src='ads.img'
                :max-height="ads.height"
                :max-width="ads.width"
                />
            </center>
          </v-flex>
        </v-layout>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
  export default {
    data () {
      return {
        ads:[
          {
            plax: 'img/parallax/plax4.jpg',
            img: 'img/ads/terminal.png',
            logo: 'img/ads/terminal_logo.png',
            text: `Wondering which jobs are due to arrive or depart today? Terminal gives you the answer at a glance. Display scheduled arrivals and
            departures with visiual indicators as to what has arrived and been delivered. Simply move the tile in Production Board and Terminal updates instantly.`,
            title: 'Terminal',
            url: '/toolkit',
            css: 'mopho hidden-sm-and-down',
            local: 0
          },
          {
            plax: 'img/parallax/plax10.jpg',
            img: 'img/ads/leaderboard.png',
            logo: 'img/ads/leaderboard_logo.png',
            text: `Who are your shops leaders? Leaderboard displays flagged hours or efficiency rankings by technician, team & departments, creating friendly
                   competition to create a culture of accountability. Simply move the tile in Production Board and watch the leaders rise.`,
            title: 'Leaderboard',
            url: '/toolkit',
            css: 'mopho hidden-sm-and-down',
            local: 0
          },
        ],
      }
    },
  }
</script>
